import React, { Component } from 'react'
import "../css/general-style.css"
import { AiFillPrinter } from "react-icons/ai"
// FONT-INVOICE-2026-10-05: V3-only config clone (bigger table text + large bold Invoice Total). To revert: import styles from '../pdfConfig/pdfInvoice2'
import styles from '../pdfConfig/pdfInvoice2V3'
import { Document, View, Page, Text, Image, pdf } from '@react-pdf/renderer'
import { NumberFormat } from '../functions/generalFunctions'
import LoadingWindow from './LoadingWindow'

/**
 * 2026-08-25 — InvoiceV3-only fork of DownloadInvoicePDF2.js. Forked instead
 * of editing the shared original because that component is also used by
 * Invoice.js and InvoicesV2.js; this fixes a real bug (misaligned/orphaned
 * rows near a page break) without touching those other screens.
 *
 * Root cause (confirmed against a real invoice PDF, PM71703):
 *
 *  1. Row-level Views (styles.Fila / styles.FilaBreak) had no `wrap={false}`.
 *     @react-pdf/renderer paginates by real measured content height, not by
 *     a fixed row count — a row landing right at that height boundary could
 *     get split/rendered oddly instead of moving whole to the next page.
 *     Sibling component InvoicePDF.js already carries this exact fix
 *     (`wrap={false}` on every row View) — it just never got copied over to
 *     this one. Applied here the same way.
 *
 *  2. The table's closing border (styles.CuerpoTablaFinal) was drawn not
 *     only on the true last row of the whole invoice, but also on every row
 *     whose position was a multiple of `breakpoint` (assumed 45 rows/page).
 *     That assumption doesn't hold — @react-pdf fits however many rows
 *     actually reach the bottom margin (confirmed: page 1 of PM71703 fit 46
 *     rows, not 45), so the closing border/line could land on a row that
 *     wasn't actually last on its page, visually cutting the table off
 *     early with real rows appearing to float below it. Fixed by keying
 *     CuerpoTablaFinal only off the true last row (`(e + 1) === Detail.length`).
 */
export class DownloadInvoicePDF2InvoiceV3 extends Component {
    // eslint-disable-next-line
    constructor(props) {

        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        showModal: false,
        lastRow: 0,


    }

    handleModalOpen = () => {
        this.setState({ showModal: true })
    }

    handleModalClose = () => {
        this.setState({ showModal: false })
    }




    calculateNewSheet() {
        let arrTam = this.props.bodyTable.length

        while (true) {
            arrTam = arrTam - 27
            if (arrTam <= 27) {
                break
            }
        }
        if (arrTam > 20) {
            return true
        }

        return false
    }

    truncDecimal(n) {
        let t = n.toString();
        let regex = /(\d*.\d{0,1})/;
        return t.match(regex)[0];
    }
    EncabezadoOrder(data, num) {
        let format = []
        let temporal = []
        let cont = 1

        for (const item of data) {
            if (cont === num) {
                temporal.push(item)
                format.push(temporal)
                temporal = []
                cont = 1

            } else {
                cont++
                temporal.push(item)
            }
        }

        return format
    }
    EncabezadoInfo(Llaves, State, Confirm) {

        let resultado = []
        Llaves.forEach(llave => {
            if (llave !== '$') {
                if (this.props.keysDecimalFormat.includes(llave) && State[llave] !== ' ') {
                    resultado.push(NumberFormat(Number(State[llave]).toFixed(2)))
                } else {
                    resultado.push(State[llave])
                }
            } else {
                if (Confirm) {
                    resultado.push(llave)
                } else {
                    resultado.push(' ')
                }



            }


        });


        return resultado
    }

    async generateDownolad() {
        await this.ModalLoading.current.showState(true);
        const blob = await pdf(
            <Document >
                <Page size="A4" wrap>
                    <View fixed>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.blockHeader}>
                                <Image style={styles.BusinessLogo} src={this.props.companyLogo} />
                            </View>
                            <View style={styles.blockHeader}>
                                <View style={styles.bolderStyle}>
                                    <Text style={styles.TypeInvoiceTitle}>{this.props.InvoiceType}</Text>
                                </View>

                            </View>
                            <View style={styles.PageInfoStyle}>
                                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                                    `Page: ${pageNumber} of ${totalPages}`
                                )} />

                            </View>
                        </View>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.block50Percent}>
                                <View style={styles.bolderStyle}>
                                    {this.props.CompanyContactInfo.map((element, e) => (
                                        <Text key={e} style={styles.HeaderTextStyle}>{element}</Text>
                                    ))}
                                </View>
                            </View>
                            <View style={styles.block50Percent}>
                                <View style={styles.BoxLeft}>
                                    {
                                        this.props.Box1.map((element, e) => (
                                            e === 0 ?
                                                <View key={e} style={styles.bolderStyle}>
                                                    <Text key={e} style={styles.TextStyleInHeaderBoxes}>{element}</Text>
                                                </View>
                                                :
                                                <Text key={e} style={styles.TextStyleInHeaderBoxes}>{element}</Text>
                                        ))
                                    }
                                </View>
                            </View>

                        </View>
                        <View style={styles.Space}></View>
                        <View style={styles.blockHeaderStyle}>
                            <View style={styles.block50Percent}>

                                {this.EncabezadoOrder(this.props.InvoiceHeader, 2).map((element, e) => (
                                    <View style={styles.SubContainerHeader} key={e}>
                                        {
                                            element.map((element2, e2) => (
                                                (e2 === 0) ?
                                                    <View key={e2} style={styles.bolderStyle}>
                                                        <View style={styles.ColumnaHeader1} key={e2}>
                                                            <Text >{element2}</Text>
                                                        </View>
                                                    </View>
                                                    :
                                                    <View style={styles.ColumnaHeader2} key={e2}>
                                                        <Text >{element2}</Text>
                                                    </View>
                                            ))
                                        }
                                    </View>
                                ))}

                            </View>
                            <View style={styles.block50Percent}>

                            </View>

                        </View>
                        <View style={styles.Space}></View>

                    </View>

                    <View style={styles.Table}>
                        <View fixed style={styles.CabeceraTabla}>

                            {
                                this.props.HeaderDescritpion.map((title, t) => (

                                    <Text style={styles[this.props.StyleDetail[t] + "Header"]} key={t}>{title}</Text>

                                ))
                            }
                        </View>
                        {
                            this.props.Detail.map((elemento, e) => (
                                // 2026-08-25 fix — CuerpoTablaFinal (closing border) now only
                                // applies to the true last row of the whole invoice, not to
                                // every assumed-45th row (see file header comment, point 2).
                                (e + 1) < this.props.Detail.length ?
                                    <View key={e} style={styles.CuerpoTabla}>{
                                        e % this.props.breakpoint === 0 && e !== 0 ?

                                            <View key={e} style={styles.FilaBreak} wrap={false}>{

                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>



                                            :

                                            <View key={e} style={styles.Fila} wrap={false}>{
                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>
                                    }
                                    </View>
                                    :
                                    <View key={e} style={styles.CuerpoTablaFinal}>{
                                        e % this.props.breakpoint === 0 && e !== 0 ?

                                            <View key={e} style={styles.FilaBreak} wrap={false}>{

                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>



                                            :

                                            <View key={e} style={styles.Fila} wrap={false}>{
                                                this.EncabezadoInfo(this.props.DescriptionKeys, elemento, (e + 1) <= this.props.quantSignDolar).map((fila, e2) => (
                                                    (e + 1) <= this.props.quantSignDolar ?
                                                        <View style={styles[this.props.StyleDetail[e2]]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                        :
                                                        <View style={styles[this.props.StyleDetail[e2] + "Clear"]} key={e2}><Text key={e2}>{fila}</Text></View>
                                                ))
                                            }</View>
                                    }
                                    </View>
                            ))
                        }


                        {/* 2026-08-25 fix — wrap={false} so the totals block
                            (Net Invoice/Freight/Invoice Total + the closing
                            message) moves whole to the next page instead of
                            splitting mid-block when the last product row
                            lands near the bottom margin. Surfaced once the
                            blank filler rows (removed above) stopped
                            incidentally pushing this block onto a fresh
                            page on its own. */}
                        <View wrap={false}>
                            {this.EncabezadoOrder(this.props.bottomInformation, 11).map((element, e) => (
                                <View key={e} style={styles.CabeceraBottom}>
                                    {
                                        element.map((title, t) => (
                                            <Text style={styles[this.EncabezadoOrder(this.props.bottomStyle, 11)[e][t]]} key={t}>{title}</Text>
                                        ))
                                    }
                                </View>

                            ))}



                            <View style={styles.blockHeaderStyle}>
                                <Text style={styles.BottomTextStyle}>{this.props.bottomMessage}</Text>
                            </View>
                        </View>
                    </View>




                </Page>
            </Document>
        ).toBlob()
        let URL = window.URL.createObjectURL(blob);
        window.open(URL, '_blank');
        await this.ModalLoading.current.showState(false);
    }


    render() {
        return (
            <React.Fragment>
                <LoadingWindow ref={this.ModalLoading} />
                <div className="d-grid gap-2">
                    <button hidden={this.props.hidden} id={this.props.id} disabled={this.props.disabled} type="button" onClick={() => this.generateDownolad()} className={"btn " + this.props.colorButton + " btn-lg"}><AiFillPrinter /> {this.props.titleButton}</button>
                </div>
            </React.Fragment>
        )
    }
}

